module.exports = __webpack_public_path__ + "img/一般贸易模式.ad374681.png";